export default __webpack_public_path__ + "static/media/xettle.afaec4ef.png";